import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';

import { TLanguage } from 'src/types/Language/language.model';
import IconVietNamFlag from 'src/components/Cores/Icons/IconVietNamFlag';
import IconEnglishFlag from 'src/components/Cores/Icons/IconEnglishFlag';
import { useAppStore } from 'src/context/AppStore';

function HeaderLanguage() {
  const { i18n } = useTranslation();
  const appStore = useAppStore();

  const listLanguage: TLanguage[] = [
    { id: 'vn', name: 'Tiếng Việt', icon: <IconVietNamFlag width="30" height="20" /> },
    { id: 'en', name: 'English', icon: <IconEnglishFlag width="20" height="10" /> }
  ];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const selectedRef = useRef(appStore.currentLanguage);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    i18n.changeLanguage(appStore.currentLanguage);
    // eslint-disable-next-line
  }, []);

  const handleMenuItemClick = (id: string) => {
    selectedRef.current = id;
    appStore.updateLanguage(id);
    i18n.changeLanguage(id);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="">
        <IconButton
          color="primary"
          onClick={handleClick}
          size="small"
          sx={{ ml: 1 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <span className="flex">{listLanguage.find(x => x.id === selectedRef.current)?.icon}</span>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {listLanguage &&
          listLanguage.map((item: TLanguage, index) => {
            return (
              <MenuItem
                key={index}
                onClick={() => handleMenuItemClick(item.id)}
                className="p-0 flex justify-between w-64"
              >
                {item.icon} {item.name}
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
}

export default observer(HeaderLanguage);
